import { clsx } from 'clsx';

export function LoadingSpinner(props: Props) {
  const isOverlay = props.mainLoader === true;

  return (
    <div
      className={clsx(
        isOverlay
          ? 'fixed inset-0 flex items-center justify-center w-full h-full'
          : 'flex items-center justify-center w-full h-24',
      )}
    >
      <div
        role="status"
        className="flex items-center justify-center"
      >
        <span
          className={clsx(
            'inline-block animate-spin rounded-full',
            isOverlay ? 'h-12 w-12 border-4' : 'h-8 w-8 border-[3px]',
            'border-gray-300 dark:border-gray-600 border-t-primary-400',
          )}
        />
      </div>
    </div>
  );
}

interface Props {
  readonly mainLoader?: boolean;
}
